import clsx from 'clsx';
import type { ReactNode } from 'react';

type Variant = 'success' | 'muted' | 'accent';

interface BadgeProps {
  variant?: Variant;
  pulse?: boolean;
  className?: string;
  children: ReactNode;
}

const variants: Record<Variant, { wrap: string; dot: string }> = {
  success: {
    wrap: 'border-[color:var(--color-accent-edge)] text-accent bg-[linear-gradient(180deg,rgb(196_255_97_/_0.18),rgb(196_255_97_/_0.06))]',
    dot: 'bg-accent shadow-[0_0_10px_var(--color-accent)]',
  },
  muted: {
    wrap: 'border-border-subtle text-text-muted bg-bg-overlay',
    dot: 'bg-text-muted',
  },
  accent: {
    wrap: 'border-[color:var(--color-accent-edge)] text-accent bg-transparent',
    dot: 'bg-accent',
  },
};

export function Badge({ variant = 'success', pulse, className, children }: BadgeProps) {
  const v = variants[variant];
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium',
        v.wrap,
        className,
      )}
    >
      <span
        aria-hidden
        className={clsx('h-1.5 w-1.5 rounded-full', v.dot, pulse && 'animate-[pulse-dot_1.6s_ease-in-out_infinite]')}
      />
      <span>{children}</span>
    </span>
  );
}
